// Auth token and device identifier
export const AUTH_TOKEN = 'token';
export const EXPIRY_TIME = 'exp_time';
export const LOGOUT_FLAG = 'isLogout';
export const IS_LOGGED_IN = 'isLoggedIn';

// Redux Store state
export const STATE = 'state';

export const SESSION_ID = 'sess_id';
export const IS_GST_VALID = 'valid_gst';
